const state = {
    successObject: {
        type: null,
        pageTitle: null,
        pageDec: null,
        successMsg: null,
        link: null,
        data: [
            { key: null, value: null }
        ]
    }
}

const getters = {}

const mutations = {
    setSuccessObject(state, paylod) {
        state.successObject = paylod
    }
}

const actions = {}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}